module.exports = __webpack_public_path__ + "70133b25b2ef80c0e2f61bad804b401f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/ss/ss05.jpg
// module id = 711
// module chunks = 0